<div class="light-flex-card">
  <div
    *ngIf="(contractSellerItems?.length > 0) && (!isLoadingItems)"
    class="table-search-button-container layout-row align-start-center">
    <app-filter-popup
      [filterItems]="allDisplayedColumns"
      [onFilterItemClick]="applyFilterToTable">
    </app-filter-popup>
    <div class="vertical-separator"></div>
    <div class="tv-round-input-extensible-no-label width-300px">
      <mat-form-field>
        <mat-label>Filtrer</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          [formControl]="searchControl"
          (input)="onSearchInput($event)"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="table" *ngIf="(contractSellerItems?.length > 0) && (!isLoadingItems)">
    <table
      [dataSource]="contractSellerItemsList"
      class="table"
      mat-table
      matSort
      (matSortChange)="onSortChange()"
      matSortActive="numClientA"
      matSortDirection="asc"
      matSortDisableClear
    >
      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th *matHeaderCellDef
            class="header-cell-center-align font-ns"
            mat-header-cell
            [mat-sort-header]="column"
            [disabled]="allDisplayedColumns[column]?.type === 'checkbox'"
            [ngClass]="(allDisplayedColumns[column]?.type === 'checkbox') ? 'custom-header-checkbox' : ''">
              {{ allDisplayedColumns[column]?.label ?? ''}}
            <mat-checkbox
              #transferAllContracts
              class="tv-blueish-grey-checkbox"
              *ngIf="(allDisplayedColumns[column]?.type === 'checkbox')"
              [checked]="false"
              [matTooltip]="'Transférer tous les contrats'"
              matTooltipClass="custom-tv-tooltip"
              (change)="onTransferAllChange($event)"
            >
            </mat-checkbox>
        </th>
        <td
          *matCellDef="let item"
          class="mat-cell-center-align"
          mat-cell
          [ngClass]="(allDisplayedColumns[column]?.type === 'checkbox') ? 'custom-checkbox-cell' : ''">
          <ng-container *ngIf="allDisplayedColumns[column]?.type !== 'checkbox'">
            {{ item[column] }}
          </ng-container>
          <mat-checkbox label="transfert"
                        class="tv-blueish-grey-checkbox"
                        *ngIf="(allDisplayedColumns[column]?.type === 'checkbox')"
                        [checked]="item?.transfer"
                        [matTooltip]="allDisplayedColumns[column]?.toolType"
                        matTooltipClass="custom-tv-tooltip"
                        (change)="onTransferChange(item, column)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
  </div>
  <p *ngIf="!(contractSellerItems?.length > 0) && !isLoadingItems">
    Veuillez saisir des paramètres
  </p>
  <div class="spinner-container width-100" *ngIf="isLoadingItems">
    <mat-spinner diameter="25" class="light-spinner"></mat-spinner>
  </div>
</div>
